export const toItems = items => items.map(toItem)

export const toItem = item => ({
  value: item.id,
  label: item.name,
  system: item.system
})

export const toUsers = users => {
  return users.map(user => ({
    value: user.id,
    label: user.userName,
    roles: user.roles
  }))
}

export const toDealStatuses = statuses => {
  return statuses.map(status => ({
    value: status.id,
    label: status.name,
    code: status.code
  }))
}
